import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { generateTrackingId } from '@frontend/call-intel-core';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Heading } from '@frontend/design-system';

type Props = {
  onClose?: () => void;
  children?: ReactNode;
};

export const CallInsightHeader = ({ children, onClose: handleClose }: Props) => {
  const { t } = useTranslation('call-insight-panel');

  return (
    <header css={styles.header}>
      <div className='top-bar'>
        <Button
          className='close-btn'
          variant='secondary'
          label={t('Close panel')}
          iconName='x'
          size='large'
          onClick={handleClose}
          trackingId={generateTrackingId({
            prefix: 'call-insight-panel',
            component: 'close-btn',
          })}
        />
      </div>
      <div
        className='header-content'
        css={{ padding: theme.spacing(2, 3), borderBottom: `1px solid ${theme.colors.neutral20}` }}
      >
        {!children ? (
          <Heading className='heading' level={2}>
            {t('Call Insights')}
          </Heading>
        ) : (
          children
        )}
      </div>
    </header>
  );
};

const styles = {
  header: css`
    display: flex;
    flex-direction: column;
    .top-bar {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      padding: ${theme.spacing(1, 2)};
      border-bottom: 1px solid ${theme.colors.neutral10};
      height: ${theme.spacing(6)};
    }
    .close-btn {
      padding: ${theme.spacing(0.5)};
      height: auto;
    }
    .header-content {
      display: flex;
      justify-content: flex-start;
      padding: ${theme.spacing(2, 3)};
      border-bottom: 1px solid ${theme.colors.neutral10};

      h2 {
        padding: ${theme.spacing(0)};
        line-height: ${theme.spacing(3.5)};
      }
    }
  `,
};
